(() => {
  const dialog = document.querySelector('[data-email-popup]');
  if (!dialog) return;

  const delaySeconds = Number(dialog.dataset.delay || 10);
  const scrollPercent = Number(dialog.dataset.scroll || 50);
  const oncePerSession = dialog.dataset.once !== 'false';
  const dismissDays = Number(dialog.dataset.dismissDays || 14);
  const successDays = Number(dialog.dataset.successDays || 90);
  const storageKey = 'enraged-email-popup';
  const sessionKey = 'enraged-email-popup-shown';
  const form = dialog.querySelector('form');
  const success = dialog.querySelector('[data-popup-success]');
  const serverError = dialog.querySelector('[data-popup-error]');

  const readStore = () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || 'null');
    } catch (error) {
      return null;
    }
  };

  const writeStore = (status, days) => {
    const until = Date.now() + days * 24 * 60 * 60 * 1000;
    try {
      localStorage.setItem(storageKey, JSON.stringify({ status, until }));
    } catch (error) {
      /* Storage can be blocked. The popup still works for this page view. */
    }
  };

  const suppressed = () => {
    const saved = readStore();
    return Boolean(saved && saved.until && Date.now() < saved.until);
  };

  const sessionSeen = () => {
    try {
      return sessionStorage.getItem(sessionKey) === '1';
    } catch (error) {
      return false;
    }
  };

  const markSession = () => {
    if (!oncePerSession) return;
    try {
      sessionStorage.setItem(sessionKey, '1');
    } catch (error) {
      /* Ignore private-mode storage failures. */
    }
  };

  const openPopup = (force) => {
    if (dialog.open) return true;
    if (force) {
      document.querySelectorAll('dialog[open]').forEach((other) => {
        if (other !== dialog) other.close();
      });
    } else if (document.querySelector('dialog[open]')) {
      return false;
    }
    try {
      dialog.showModal();
    } catch (error) {
      return false;
    }
    markSession();
    const focusTarget = dialog.querySelector('[data-initial-focus]');
    if (focusTarget) focusTarget.focus();
    return true;
  };

  dialog.addEventListener('close', () => {
    if (success) writeStore('subscribed', successDays);
    else writeStore('dismissed', dismissDays);
  });

  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    dialog.close();
  });

  const copyButton = dialog.querySelector('[data-copy-code]');
  const codeEl = dialog.querySelector('[data-discount-code]');
  if (copyButton && codeEl) {
    copyButton.addEventListener('click', async () => {
      const code = codeEl.textContent.trim();
      try {
        await navigator.clipboard.writeText(code);
        copyButton.textContent = 'Copied';
      } catch (error) {
        const range = document.createRange();
        range.selectNodeContents(codeEl);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        copyButton.textContent = 'Select the code';
      }
    });
  }

  if (form && !success) {
    form.noValidate = true;
    const emailInput = form.querySelector('input[type="email"]');
    const clientError = form.querySelector('[data-client-error]');
    const submit = form.querySelector('[type="submit"]');

    form.addEventListener('submit', (event) => {
      const email = emailInput ? emailInput.value.trim() : '';
      const emailValid = emailInput && emailInput.validity.valid && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!emailValid) {
        event.preventDefault();
        if (clientError) {
          clientError.hidden = false;
          clientError.textContent = 'Enter a valid email address.';
        }
        if (emailInput) {
          emailInput.setAttribute('aria-invalid', 'true');
          emailInput.focus();
        }
        return;
      }
      if (form.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }
      form.dataset.submitting = 'true';
      if (submit) submit.disabled = true;
    });
  }

  const params = new URLSearchParams(window.location.search);
  const subscribed = dialog.dataset.subscribed === 'true';
  const forceOpen = params.has('preview_theme_id') || window.location.hash === '#popup' || params.get('popup') === '1';

  if (success) {
    writeStore('subscribed', successDays);
    openPopup(true);
    return;
  }

  if (serverError) {
    openPopup(true);
    return;
  }

  if (forceOpen) {
    openPopup(true);
    return;
  }

  if (subscribed) return;
  if (suppressed()) return;
  if (oncePerSession && sessionSeen()) return;

  let opened = false;
  const tryOpen = () => {
    if (opened || dialog.open || suppressed()) return;
    if (document.querySelector('dialog[open]')) return;
    if (!openPopup()) return;
    opened = true;
    window.removeEventListener('scroll', onScroll);
    window.clearTimeout(timer);
  };

  const timer = window.setTimeout(tryOpen, Math.max(0, delaySeconds) * 1000);

  const onScroll = () => {
    const root = document.documentElement;
    const max = root.scrollHeight - root.clientHeight;
    if (max <= 0) return;
    const progress = (window.scrollY || root.scrollTop) / max * 100;
    if (progress >= scrollPercent) tryOpen();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
